import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { Bell } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { MockNotification } from '@/mock/notifications'

export interface NotificationItemProps extends Partial<MockNotification> {
  title: string
  nextButtonLabel?: string
  onButtonNext: () => void
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  onButtonNext,
  title,
  nextButtonLabel,
  date,
  message,
}) => {
  const theme = useTheme()

  // Date formatting (simplified version)
  const dateFormatted = date
    ? new Date(date)
        .toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
        .replace('AM', 'am')
        .replace('PM', 'pm')
    : ''

  const kemLogoSize = 48

  return (
    <BaseView
      fullWidth
      row
      align="flex-start"
      gap={12}
      p={16}
      style={{
        backgroundColor: 'transparent',
        borderRadius: '0px',
      }}
    >
      {/* Avatar with notification icon */}
      <BaseView
        circle
        circleSize={kemLogoSize}
        center
        style={{
          backgroundColor: theme.colors.background.buttonSecondaryEnabled,
          flexShrink: 0,
        }}
      >
        <Bell color={theme.colors.icon.iconCard} size={24} />
      </BaseView>

      {/* Content */}
      <BaseView flex={1} gap={12}>
        {/* Title and date */}
        <BaseView gap={6}>
          <BaseText
            style={{
              fontSize: '16px',
              fontWeight: '600',
              color: theme.colors.label.primary,
            }}
          >
            {title}
          </BaseText>

          {date && (
            <BaseText
              style={{
                fontSize: '14px',
                color: theme.colors.label.description,
              }}
            >
              {dateFormatted}
            </BaseText>
          )}
        </BaseView>

        {/* Message */}
        {message && (
          <BaseText
            style={{
              fontSize: '14px',
              color: theme.colors.label.primary,
              lineHeight: '1.4',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {message}
          </BaseText>
        )}

        {/* Action button */}
        {nextButtonLabel && (
          <BaseView fullWidth style={{ marginTop: '4px' }}>
            <AppButton
              size="small"
              onPress={onButtonNext}
              isSharedSpace
              style={{
                width: '100%',
              }}
            >
              {nextButtonLabel}
            </AppButton>
          </BaseView>
        )}
      </BaseView>
    </BaseView>
  )
}
